import { Role } from "./definitions";

export interface GrandItem {
    role?: Role;
    resource: string;
    action: 'create' | 'show' | 'list' | 'clone' | 'edit' | 'delete' | '';
    attributes?: string[];
}

export function checkGrant(grantList: GrandItem[], RBAC: { role: string, resource?: string, action: string }) {
    for (const grant of grantList) {
        if ((!grant.role || grant.role == RBAC.role) && grant.resource == RBAC.resource && grant.action == RBAC.action) {
            return {
                granted: true,
                attributes: grant.attributes ?? []
            }
        }
    }
    return {
        granted: false,
        attributes: []
    }
}

enum CheckState {
    whiteList,
    blackList
}

export function checkAttributes(grantedAttributes: string[], checkAttributes: string[]) {
    if (grantedAttributes.length == 0) return true
    const state = grantedAttributes.includes('*') ? CheckState.blackList : CheckState.whiteList
    if (state == CheckState.whiteList && checkAttributes.length == 0) {
        return false
    }
    for (const attr of grantedAttributes) {
        if (state == CheckState.whiteList && !checkAttributes.includes(attr)) {
            return false
        }

        if (state == CheckState.blackList && /!\w/.test(attr) && checkAttributes.includes(attr.slice(1))) {
            return false
        }
    }
    return true
}
